module.exports = __webpack_public_path__ + "img/0726_V0A.95561f61.svg";